import { required } from '@vuelidate/validators'
import { createRule } from './common'
import { REQUIRED_ERROR } from './errorMessages'

const { $validator: isValid } = required

export default createRule({ isValid, errorMessage: REQUIRED_ERROR })
